import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ roles, children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null)
    return (
      <div className="flex-1 grid place-items-center py-24" data-testid="auth-loading">
        <Loader2 className="animate-spin text-[#0D5C46]" />
      </div>
    );
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};
